import translation from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

translation
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'pt',
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: {
          welcome: 'Welcome to my website!',
          price: 'Price',
        },
      },
      pt: {
        translation: {
          welcome: 'Bem-vindo ao meu site!',
          price: 'Preço',
          need_help_contact_us: 'Se tem dúvidas, pergunte-nos!',
          need_help_contact_us_button: 'Contacte-nos!',
          ironing_sara: 'Engomadoria Sara',
          ironing_title: 'Lavandaria e Engomadoria',
          ironing_description:
            'Oferecemos serviço completo lavandaria e engomadoria para que não tenha que se preocupar com nenhuma destas tarefas domésticas.',
          sewing_description: 'Oferecemos um serviço completo de costura para dar uma segunda vida a sua roupa.',
          default_home: 'Página inicial',
          default_contacts: 'Contactos',
          default_services: 'Serviços',
          default_ironing: 'Engomadoria',
          ironing_package: 'Engomadoria pacotes',
          default_sewing: 'Costura',
          default_phone_number: '211 819 730',
          default_article: 'Artigo',
          default_price: 'Preço',
          ironing: "Engomagem",
          default_email_address: "tatianapt64@gmail.com",
          default_shop_address: "Avenida Bocage, 15 A - R/C,\n 2830-003 Barreiro",
          default_washing_and_ironing_tshirt_package: 'Pacote de camisas',
          default_washing_and_ironing_tshirt_package_label: 'Não inclui casacos, vestidos compridos, capas de edredon, cortinados',
          washing_ironing_dry_clean_by_piece: 'Limpeza a seco \\ Lavagem e Engomagem á peça',
          dry_cleaning: 'Limpeza a seco',
          washing_ironing_dry_clean: 'Limpeza a seco \\ Lavagem e Engomagem',
          assorted_clothes: 'Roupa Sortida até 30% camisas',
          assorted_clothes_without_shirts: 'Roupa Sortida sem camisas',
          default_iron_by_piece: 'Engomar á peça',
          sofa_and_carpet_cleaning: 'Limpeza de Sofas e Carpetes',
          sofa_and_carpet_cleaning_description_title: 'Limpeza e higienização dos sofás e carpetes',
          sofa_and_carpet_cleaning_description:
            'Somos especialistas em limpeza e higienização profissional de sofás, removendo toda a sujidade, manchas, ácaros, odores e bactérias, tornando dessa forma, o ambiente muito mais agradável e saudável para toda a família.\n\n Devolvemos ao seu sofá o seu aspecto original, deixando-o praticamente como novo!',
          home_page_about_us: 'Sobre nós',
          home_page_about_us_description_list_title: "O nosso serviço de limpeza engloba:",
          home_page_about_us_description:
            'Na Engomadoria Sara, dedicamo-nos a cuidar da sua roupa como se fosse nossa. Com uma equipa experiente e atenta ao detalhe, oferecemos serviços de engomadoria de alta qualidade, garantindo que cada peça fica impecável. Trabalhamos com roupas do dia a dia, peças delicadas, fatos, roupas de cama e muito mais. Se procura poupar tempo e ter sempre tudo pronto a usar, conte connosco para dar um toque de frescura e cuidado ao seu guarda-roupa.',
          home_page_about_us_description_list: ['Costura', 'Lavagem e limpeza a seco', 'Engomadoria'],
          home_page_where_finds_us: "Onde nos encontrar",
          home_page_dont_hesitate_contact_us: "Não hesite em contactar-nos!",
          default_schedule: "Horário",
          home_page_schedule_monday_to_friday: "Segunda-feira á sexta-feira",
          home_page_schedule_monday_to_friday_time: "09:00–13:00, 15:00–19:00",
          home_page_schedule_saturday: "Sábado",
          home_page_schedule_saturday_time: "09:00–13:00",
          home_page_schedule_sunday: "Domingo",
          home_page_schedule_sunday_time: "encerrado",
          home_page_schedule_ti: "Não hesite em contactar-nos!",
          default_facebook_link: "https://www.facebook.com/engomadoriasara",
          home_page_write_us: 'ESCREVA-NOS',
          home_page_visit_us: 'VISITE-NOS',
          home_page_contact_us: 'CONTACTE-NOS',
          home_page_call_us: 'LIGUE-NOS',
          home_page_call_us_description: '211 819 730',
          home_page_follow_us: 'SEGUE-NOS',
          home_page_title_description: 'Tenha a sua roupa lavada e engomada em três passos.',
          sewing_page_men_coats: 'Casacos de Homem',
          sewing_page_men_pants: 'Calças de Homem',
          sewing_page_men_shirts: 'Camisas de Homem',
          sewing_page_jackets: 'Blusões',
          sewing_page_curtains: 'Cortinados',
          sewing_page_jeans: 'Calças de Ganga',
          sewing_page_skirts: 'Saias',
          sewing_page_ceremony_dress: 'Vestidos de Cerimónia',
          sewing_page_linings: 'Forros',
          sewing_page_knitwear_blouses_shirts_polo: 'Malhas Blusas T-shirts Polos',
          footer_links: "Links Úteis",
          table: {
            minQuantities: "A partir das {{minQuantity}} peças",
            minMaxQuantities: "A partir das {{minQuantity}} até {{maxQuantity}} peças",
          },
          attribution: {
            default: "Attribution",
            freePick: "Illustration by Freepik"
          }
        },
      },
    },
  });

export default translation;
